<template>
  <div class="license-wrapper">
    <!--Info-->
    <div class="info-wrapper">
      <h3>Licenses</h3>
      <div class="license-count">
        <span class="licenses-used">{{ users.length }}</span>
        <em>of</em>
        <span class="total-licenses">{{
          subscription.licenses.quantity || 0
        }}</span>
        <em>licenses used</em>
      </div>
      <button class="btn btn-primary btn-small" @click="manageLicenses">
        Assign Licenses
      </button>
    </div>

    <!--Licenses-->
    <div v-if="users.length > 0" class="grid-table-wrapper">
      <ul
        class="grid-table grid-header"
        :class="{ 'grid-header-shadow': showOptions.headerShadow }"
      >
        <li class="grid-row">
          <span class="grid-column">Agent</span>
          <span class="grid-column">Role</span>
          <span class="grid-column">Access</span>
        </li>
      </ul>
      <ul class="grid-table grid-table-body" ref="table" @scroll="tableScroll">
        <li v-for="(user, index) in users" :key="index" class="grid-row">
          <div class="grid-column">
            <h3 class="name">{{ user.name }}</h3>
            <span class="email">{{ user.email }}</span>
          </div>

          <div class="grid-column">
            <span :class="`table-tag ${getTagColor(user.role)}`">{{
              user.role
            }}</span>
          </div>

          <div class="grid-column">
            <span class="table-tag green">Has Access</span>
          </div>
        </li>
      </ul>

      <!--Agent Count-->
      <span class="grid-count"
        >Showing {{ users.length }}
        {{ users.length == 1 ? "agent" : "agents" }}</span
      >
    </div>

    <!--Zero State -->
    <ZeroState
      v-else
      class="zero-state"
      :imageURL="zeroStateData.imageURL"
      :title="zeroStateData.title"
      :message="zeroStateData.message"
      :buttonTitle="zeroStateData.buttonTitle"
      @eventHandler="manageLicenses"
    ></ZeroState>
  </div>
</template>
      
<script>
// Components
import ZeroState from "@/components/misc/ZeroState";

export default {
  name: "Licenses",
  props: {},
  data() {
    return {
      showOptions: {
        headerShadow: false,
      },
      zeroStateData: {
        imageURL: "services.jpg",
        title: "No licenses assigned",
        message: "Assign licenses to your agents to give them access",
        buttonTitle: "Assign Licenses",
      },
    };
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    selectedApp() {
      return this.$store.getters.selectedApp;
    },
    subscription() {
      return this.selectedApp.subscription;
    },
    users() {
      return this.subscription?.licenses?.users || [];
    },
  },
  components: {
    ZeroState,
  },
  methods: {
    // Event on table scroll
    tableScroll() {
      const scrollTop = this.$refs.table.scrollTop;

      // Check if header needs shadow
      if (scrollTop > 0) this.showOptions.headerShadow = true;
      else this.showOptions.headerShadow = false;
    },

    // Tag color based on role
    getTagColor(role) {
      switch (role) {
        case "admin":
          return "zendesk";
        case "agent":
          return "";
        default:
          break;
      }
    },

    // Manage licenses
    manageLicenses() {
      this.$emit("manageLicenses");
    },
  },
};
</script>
      
<style scoped lang="scss">
@import "@/assets/styles/shared/dashboard.scss";

.info-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 1rem;

  h3 {
    font-family: $titleFont;
    font-size: $mediumFontSize;
    margin-bottom: 0.5rem;
    flex: 1;
  }

  p {
    font-size: $smallFontSize;
    opacity: $lightOpacity;
  }
}

.grid-column {
  &:nth-child(2),
  &:nth-child(3) {
    text-align: center;
  }
}

.name {
  font-size: $smallFontSize;
  font-weight: $mediumFontWeight;
}

.email {
  font-size: $smallerFontSize;
  color: $greyColor;
}

.license-count {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 1rem;

  span {
    font-size: $mediumFontSize;
    font-weight: $boldFontWeight;
    line-height: 1rem;
    margin-right: 0.25rem;
  }

  em {
    color: $greyColor;
    line-height: 1rem;
    margin-right: 0.25rem;
  }
}
</style>